<template>
<div id="footer">
  <b-navbar toggleable="lg" type="green" variant="green"
  class="shadow-sm p-3 mb-5 bg-green rounded">
    <b-navbar-brand center id="logo">
      <router-link to="/"><img alt="Logo" src="../assets/logo.png"></router-link>
    </b-navbar-brand>
    <b-navbar-nav>
    <b-nav-item id="footer-link-fixer" href="http://fishrpc.kz/">ТОО «Научно-производственный центр рыбного хозяйства»</b-nav-item>
    <b-nav-text>
    <div id="text_icl-9" class="woodmart-widget widget footer-widget widget_text_icl">
  <div class="textwidget"><div class="social-flexer">
 <a href="https://ru-ru.facebook.com/kazniirh/"><img src="../assets/md_5b321ca7cfbef.png"></a>
    <div class="infoo"><p>
      <font-awesome-icon icon="map-marker" /> Республика Казахстан, 050016,<br>
г. Алматы пр. Суюнбая, 89 «А»</p></div>
    <div class="inoo-mobile">
    <p><font-awesome-icon icon="phone" /> 8 (727) 383-17-15</p>
    <p><font-awesome-icon icon="envelope" /> <a href="mailto:info@fishrpc.kz">info@fishrpc.kz</a>
    </p>
</div>
</div></div>
</div>
    </b-nav-text>
</b-navbar-nav>
  </b-navbar>
  </div>
</template>

<script>

export default {
  computed: {
    translate() {
      const lang = this.$store.state.calc.currentLocale;
      return this[lang];
    },

  },
  data() {
    return {
      kz: {
        main: 'Бастысы',
        about: 'Біз жайлы',
        contact: 'Байланыстар',
        general: 'Басты сайтқа оралу',
        url: 'http://fishrpc.kz/%d0%b1%d0%b0%d0%b9%d0%bb%d0%b0%d0%bd%d1%8b%d1%81/?lang=kz',
      },
      ru: {
        main: 'Главная',
        about: 'О нас',
        contact: 'Контакты',
        general: 'Вернуться на главный сайт',
        url: 'http://fishrpc.kz/%d0%ba%d0%be%d0%bd%d1%82%d0%b0%d0%ba%d1%82%d1%8b/?lang=ru',
      },
    };
  },
  components: {
  },
};
</script>


<style scoped>
    #footer .navbar {
        background-color: #00a444;
        padding:0 !important;
    }
    #footer {
      padding-top:100px;
    }

    #footer #logo {
      padding-left:50px;
    }

    #footer a {
      color: #fff;
    }
    #footer .social-flexer img {
    width: 60px;
    }

    #footer img {
    max-width: 100%;
    height: auto;
    vertical-align: middle;
    border: 0;
    margin: 15px;
    }
    #footer .social-flexer {
    display: flex;
    justify-content: center;
    }

    #footer .infoo {
    display: flex;
    align-items: center;
    padding: 20px;
    }

    #footer .inoo-mobile {
    display: flex;
    justify-content: center;
    flex-direction: column;
    padding: 20px;
    }
    #footer .footer-column.footer-column-2.col-12.col-sm-6 {
    display: flex;
    justify-content: center;
    flex-direction: column;
    padding: 20px;
    }

    #footer #footer-link-fixer {
      padding-top:35px;
    }

    #footer p {
      color:#fff;
      margin:0;
      text-align:left;
    }

</style>
